import {
    postAvatarWRAudioAction,
    WR_PRACTICE_POST_AUDIO_CALLBACK,
} from '../../wr/pages/practice/WRPracticeAvatarActions';

const CALLBACK_MAP = {
    [WR_PRACTICE_POST_AUDIO_CALLBACK]: postAvatarWRAudioAction,
};

export const getIsAvatarReadyToAnimate = state => state.isReadyToAnimate;

export const getAvatarSpeaking = state => state.isSpeaking;

export const getAvatarPosition = state => state.position;

export const getAvatarInstructions = state => state.instructions;

export const getAvatarOnTransitionEnd = state => state.onTransitionEnd;

export const getPostAudioCallback = state => {
    if (state.postAudioCallback) {
        return CALLBACK_MAP[state.postAudioCallback];
    }
    return undefined;
};

export const getAvatarCanSpeak = state => state.canSpeak;

export const getShouldAnimateAlex = state => state.animateAlex;
